import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import {WorkPermit} from '../../../model/work-permit';
import {LocalizedText} from '../../../model/localized-text';
import {FormatService} from '../../../services/format.service';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { UnlimitedDatePipe } from '../../../pipes/unlimited-date.pipe';

@Component({
    selector: 'myabvv-permit-works',
    standalone: true,
    templateUrl: './permit-works.component.html',
    styleUrls: ['./permit-works.component.css'],
    imports: [DatePipe, TranslatePipe, UnlimitedDatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PermitWorksComponent implements OnInit {
  private formatService = inject(FormatService);

  @Input() workPermits: WorkPermit[];

  ngOnInit() {
  }

  getTranslatedData(array: LocalizedText[]): string {
    return this.formatService.getTranslatedData(array);
  }

  isExpired(endDate: string): boolean {
    if (!endDate) return false;
    const end = new Date(endDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return end < today;
  }
}
